import WarningModal from 'src/components/WarningModal'

type Props = {
  open: boolean
  onCancel: () => void
  onConfirm: () => void
}

const ConfirmCloseModal = ({ open, onCancel, onConfirm }: Props) => {
  return (
    <WarningModal
      isOpen={open}
      onClose={onCancel}
      onConfirm={onConfirm}
      title='Warning! Before You Proceed'
      description={
        <>
          You have unsaved changes.
          <br />
          Closing this wizard will discard them.
        </>
      }
      cancelLabel='KEEP EDITING'
      confirmLabel='DISCARD'
      destructive
    />
  )
}

export default ConfirmCloseModal
